// extracted by mini-css-extract-plugin
export default {"logo":"LogoType_logo__wc+d8","collapsed":"LogoType_collapsed__4ETs7"};